export default __webpack_public_path__ + "static/media/Path1669-Yono.30b3da92.png";